import { type FC, useContext } from 'react'

import { Salutation } from '../../../user-data'
import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const LoginRegistrationSalutation: FC = () => {
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState
  const error = model.validator.getFirstErrorFor('salutation')

  return (
    <Salutation
      dataQaIdPrefix="register-form"
      error={error}
      onChange={(value) => {
        registrationFormState.setValue(value, model, 'salutation')
      }}
      required
      value={model.salutation}
    />
  )
}
